import { nodeListForEach } from 'Utils/common'

import Contents from "Components/contents/contents";

const $lists = document.querySelectorAll('.sta-contents')
nodeListForEach($lists, function ($list) {
	new Contents($list).init()
})